var map = {
	"./address.svg": 89587,
	"./cart.svg": 46775,
	"./cexu.svg": 95608,
	"./daishouhuo.svg": 84100,
	"./dianji.svg": 93242,
	"./dollar.svg": 52767,
	"./fenxi.svg": 31817,
	"./huiyuan.svg": 41130,
	"./inquiry.svg": 47512,
	"./jinxinzhong.svg": 35815,
	"./jiyin.svg": 27578,
	"./kangti.svg": 84237,
	"./myCart.svg": 36785,
	"./order_online.svg": 59159,
	"./pro.svg": 26366,
	"./shiji.svg": 12858,
	"./shouhuo.svg": 86176,
	"./star.svg": 40613,
	"./tip.svg": 35716,
	"./user.svg": 60792,
	"./vip.svg": 62682,
	"./yinwu.svg": 83556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30279;